import styles from './QuizQuestion.module.css';

const QuizQuestion = ({ 
  question, 
  currentIndex, 
  totalQuestions, 
  onAnswerSelect, 
  selectedAnswer, 
  isSubmitted = false,
  isScaleMode = false
}) => {
  const { questionText, prompt, options } = question;

  const handleSelect = (optionText) => {
    if (!isSubmitted) {
      onAnswerSelect(optionText);
    }
  };

  return (
    <div className={styles.questionWrapper}>
      <div className={styles.progress}>
        Question {currentIndex + 1} of {totalQuestions}
      </div>
      <h2 className={styles.questionText}>{prompt || questionText}</h2>

      {isScaleMode ? (
        <div className={styles.scaleWrapper}>
          {options.map((option, idx) => (
            <div key={option.label} className={styles.scaleItem}>
              <button
                className={`${styles.scaleButton} ${
                  String(selectedAnswer) === option.text ? styles.selected : ''
                }`}
                onClick={() => handleSelect(option.text)}
                disabled={isSubmitted}
              >
                {option.text.trim()}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.optionsWrapper}>
          {options.map((option) => (
            <button
              key={option.label}
              className={`${styles.optionButton} ${
                String(selectedAnswer) === option.text ? styles.selected : ''
              }`}
              onClick={() => handleSelect(option.text)}
              disabled={isSubmitted}
            >
              <span className={styles.optionLabel}>{option.label}.</span>
              <span className={styles.optionText}>
                {option.text.trim()}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuizQuestion;